import React from 'react'
import PropTypes from 'prop-types'
import { DownloadIcon, SpinnerAnimatedIcon } from 'secondstep-components'
import CSVReportsDropdown from 'components/ReportsNavHeader/CSVReportsDropdown'
import { ExportButtonWrapper, StyledAdminTooltip } from './component.styles'

const AdminExportDownloadButton = ({
  className,
  historicalReports,
  historicalReportingOnClick,
  isFetching,
  onClickCurrentYear,
  programKey,
  tooltipLocation,
  buttonText,
}) => {
  const Icon = isFetching ? SpinnerAnimatedIcon : DownloadIcon

  return (
    <ExportButtonWrapper className={className}>
      <CSVReportsDropdown
        buttonIcon={Icon}
        buttonText={buttonText}
        excludeLabels={true}
        historicalReportingOnClick={historicalReportingOnClick}
        historicalReports={historicalReports}
        isFetching={isFetching}
        onClickCurrentYear={onClickCurrentYear}
        showLoadingText={false}
      />
      <StyledAdminTooltip
        location={tooltipLocation}
        monitorView
        programKey={programKey}
      />
    </ExportButtonWrapper>
  )
}

AdminExportDownloadButton.propTypes = {
  buttonText: PropTypes.string,
  className: PropTypes.string,
  historicalReportingOnClick: PropTypes.func,
  historicalReports: PropTypes.array,
  isFetching: PropTypes.bool,
  onClickCurrentYear: PropTypes.func,
  programKey: PropTypes.string,
  tooltipLocation: PropTypes.string,
}

export default AdminExportDownloadButton
